import clamp from 'lodash/clamp'
import React from 'react'

import styles from './Highlight.css'

type Match = {from: number; to: number}

type Props = {
  string: string
  matches: Match[]
  offset?: number
}

export function Highlight({string, matches, offset = 0}: Props) {
  const result = []
  let prevTo = 0
  for (const match of matches) {
    const from = clamp(match.from - offset, 0, string.length)
    const to = clamp(match.to - offset, 0, string.length)
    if (prevTo < string.length && from > 0) {
      result.push(string.slice(prevTo, from))
    }
    if (from < string.length && to > 0) {
      result.push(
        <span key={`${from}-${to}`} className={styles.highlight}>
          {string.slice(Math.max(from, 0), to)}
        </span>,
      )
    }
    prevTo = to
  }
  if (prevTo < string.length) {
    result.push(string.slice(prevTo))
  }
  return <>{result}</>
}
